import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado, por favor inicia sesión");
  return { Authorization: `Bearer ${token}` };
};

export const listCourierControl = async (params = {}) => {
  const response = await axios.get(`${API_URL}/api/courier-control`, {
    headers: authHeaders(),
    params,
  });
  return response.data;
};

export const getCourierControl = async (id) => {
  const response = await axios.get(`${API_URL}/api/courier-control/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const createCourierControl = async (payload) => {
  const response = await axios.post(`${API_URL}/api/courier-control`, payload, {
    headers: authHeaders(),
  });
  return response.data;
};

export const updateCourierControl = async (id, payload) => {
  const response = await axios.put(
    `${API_URL}/api/courier-control/${id}`,
    payload,
    {
      headers: authHeaders(),
    },
  );
  return response.data;
};

export const deleteCourierControl = async (id) => {
  const response = await axios.delete(`${API_URL}/api/courier-control/${id}`, {
    headers: authHeaders(),
  });
  return response.data;
};

export const getCourierControlByMuestra = async (idMuestra) => {
  const response = await axios.get(
    `${API_URL}/api/courier-control/por-muestra/${idMuestra}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const markCourierEntregadoForMuestra = async (idMuestra) => {
  const response = await axios.post(
    `${API_URL}/api/courier-control/por-muestra/${idMuestra}/entregado`,
    {},
    { headers: authHeaders() },
  );
  return response.data;
};

/** ARRIVED SDS: cierra Courier o crea llegada sintética (sin SENT previo). */
export const registerLlegadaSdsForMuestra = async (idMuestra, fecha = null) => {
  const response = await axios.post(
    `${API_URL}/api/courier-control/por-muestra/${idMuestra}/llegada-sds`,
    fecha ? { fecha } : {},
    { headers: authHeaders() },
  );
  return response.data;
};

export const searchMuestrasCourier = async (q) => {
  const response = await axios.get(`${API_URL}/api/courier-control/muestras`, {
    headers: authHeaders(),
    params: { q },
  });
  return response.data;
};

export const getCourierMuestraLineaFields = async (idMuestra) => {
  const response = await axios.get(
    `${API_URL}/api/courier-control/muestras/${idMuestra}/linea-fields`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const listCourierPendientes = async () => {
  const response = await axios.get(
    `${API_URL}/api/courier-control/pendientes`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const createCourierDesdeMuestras = async (payload) => {
  const response = await axios.post(
    `${API_URL}/api/courier-control/desde-muestras`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};
